import { Component, Input, Output, EventEmitter } from "@angular/core";
import { DataManager } from "techlify-ng";
import { RequestErrorService } from "techlify-ng";
import { AlertService } from "techlify-ng";

import { ReceiptFormat } from "./receipt-format.model";

@Component({
  selector: "receipt-format-enable-button-selector",
  templateUrl: "./receipt-format-enable-button-selector.html"
})
export class ReceiptFormatEnableButtonSelectComponent {

  @Input() format: ReceiptFormat;
  @Output() onSave = new EventEmitter<ReceiptFormat>();

  constructor(private dataManager: DataManager,
    private alertService: AlertService,
    private errorHandler: RequestErrorService) { }

  enable() {
    this.dataManager.PATCH("api/receipt-formats/" + this.format.id + "/status-update-active", this.format).then(
      res => {
        this.onSave.emit(res.item);
        this.alertService.addAlert('Successfully enable Receipt Format.', "success");
      },
      error => {
        this.errorHandler.handleError(error);
      }
    );
  }

}
